module.exports = __webpack_public_path__ + "static/media/image.8220dfa5.png";